
export const API_ERROR = 'AD_API_ERROR';
export const SET_AD = 'SET_AD';
export const EDIT_AD = 'EDIT_AD';
export const UPDATE_AD = 'UPDATE_AD';
